import React, { useState, useEffect, Suspense } from 'react';
import { Tabs, Tab, Paper, withStyles, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { parseURL, BackButton, hasPermission } from '../../../sc-utilities';
import * as actions from '../store/userActions';
import { updateURL } from '../../../sc-utilities';
import {fetchBulkChangeUsersGroup, fetchGroups} from '../../../sc-group/Group/store/groupActions';
import {editIndividualLicenses} from "../store/userActions";

const RoleForCustomer = React.lazy(async () => await import('./RoleForCustomer'));
const RoleExcluded = React.lazy(async () => await import('./RoleExcluded'));
const UserEdit = React.lazy(async () => await import('./UserEdit'));
const ChoseCustomers = React.lazy(async () => await import('./ChoseCustomers'));

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 3 * 3 }}>
            {props.children}
        </Typography>
    );
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

const UserComponents = props => {
    const { classes, theme, activeCustomer, translations, onLoadUser, users, onFetchCustomers, saveCustomers, permissions, cleanState, onFetchBulkChangeUsersGroup, onEditIndividualLicenses, activeCustomerIndividualLicensingSetting } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());
    const [customers, setCustomers] = useState([]);

    const customersSelect = users && users.loaded && users.loaded.Customers ? users.loaded.Customers.map(id => id.CustomerID) : [];

    useEffect(() => {
        const fetchData = async () => {
            await onLoadUser({ UserID: searchParams.userID, ActiveCustomerID: activeCustomer });
            const customers = await onFetchCustomers({ ActiveCustomerID: activeCustomer });
            setCustomers(customers)
        }
        fetchData();
        return () => {
            cleanState()
        };
    }, [activeCustomer, searchParams.userID, onLoadUser, onFetchCustomers, users.edited, cleanState]);

    const handleChange = (event, value) => {
        if (value === 2 && customersSelect.length === 0) {
            updateURL(1);
            setTabValue(1);
        }
        else {
            updateURL(value);
            setTabValue(value);
        }
    };

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const hasAssignRoleToAllCustomersPermission = hasPermission(permissions, 'assign_role_to_all_customers');

    return (
        <>
            <Paper className={classes.root}>
                {BackButton(translations)}
                {!hasPermission(permissions, 'su_user_load') ? <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    {hasPermission(permissions, 'user_load') ? <Tab label={translations["user"] || "User "} /> : null}
                    {hasPermission(permissions, 'user_load') ? <Tab label={translations["access_control"] || "Access control"} /> : null}
                </Tabs>
                    :
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        {hasPermission(permissions, 'user_load') ? <Tab label={translations["user"] || "User "} /> : null}
                        {hasPermission(permissions, 'user_load') ? <Tab label={translations["customers"] || "Customers "} /> : null}

                        {hasPermission(permissions, 'user_load') ? <Tab label={translations["access_control"] || "Access control"} /> : null}
                    </Tabs>
                }
            </Paper>
            <Paper className={classes.root}>
                {!hasPermission(permissions, 'su_user_load') ?
                    <>
                        {hasPermission(permissions, 'user_load') ? <TabPanel index={0} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><UserEdit onFetchGroups={props.onFetchGroups} onEditUser={props.onEditUser} onLoadUser={onLoadUser} onFetchBulkChangeUsersGroup={onFetchBulkChangeUsersGroup} onEditIndividualLicenses={onEditIndividualLicenses} activeCustomerIndividualLicensingSetting={activeCustomerIndividualLicensingSetting} translations={translations} user={users.loaded} activeCustomer={activeCustomer} permissions={permissions} /></Suspense></TabContainer></TabPanel> : null}
                        {hasPermission(permissions, 'user_load') ? <TabPanel index={1} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><RoleExcluded hasAccessAllGroupsPermission={hasAccessAllGroupsPermission} updatePermission={props.updatePermission} tabValue={tabValue} roleID={users.loaded} onLoadRoles={props.onLoadRoles} onEditUser={props.onEditUser} translations={translations} activeCustomer={activeCustomer} fetchPermission={props.fetchPermission} /></Suspense></TabContainer></TabPanel> : null}
                    </> :
                    <>
                        {hasPermission(permissions, 'user_load') ? <TabPanel index={0} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><UserEdit onFetchGroups={props.onFetchGroups} onFetchCustomer={props.onFetchCustomer} onEditUser={props.onEditUser} onLoadUser={onLoadUser} onFetchBulkChangeUsersGroup={onFetchBulkChangeUsersGroup} activeCustomerIndividualLicensingSetting={activeCustomerIndividualLicensingSetting} onEditIndividualLicenses={onEditIndividualLicenses} translations={translations} user={users.loaded} activeCustomer={activeCustomer} permissions={permissions} /></Suspense></TabContainer></TabPanel> : null}
                        {hasPermission(permissions, 'user_load') ? <TabPanel index={1} value={tabValue}><TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ChoseCustomers UserID={searchParams.userID} saveCustomers={saveCustomers} setCustomers={setCustomers} customers={customers} setTabValue={setTabValue} updateURL={updateURL} onFetchCustomers={onFetchCustomers} tabValue={tabValue} translations={translations} user={users.loaded} activeCustomer={activeCustomer} /></Suspense></TabContainer></TabPanel> : null}
                        {hasPermission(permissions, 'user_load') ? <TabPanel index={2} value={tabValue}><TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><RoleForCustomer hasAccessAllGroupsPermission={hasAccessAllGroupsPermission} hasAssignRoleToAllCustomersPermission={hasAssignRoleToAllCustomersPermission} customers={customers} updatePermission={props.updatePermission} tabValue={tabValue} roleID={users.loaded} onLoadRoles={props.onLoadRoles} onEditUser={props.onEditUser} translations={translations} user={users.loaded} activeCustomer={activeCustomer} fetchPermission={props.fetchPermission} /></Suspense></TabContainer></TabPanel> : null}
                    </>
                }
            </Paper>
        </>
    );
}

const mapStateToProps = state => {
    return {
        users: state.user.users,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeCustomerIndividualLicensingSetting: state?.core?.login?.activeCustomer?.IndividualLicensingSetting ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};


const mapDispatchToProps = dispatch => {
    return {
        saveCustomers: data => dispatch(actions.saveCustomers(data)),
        updatePermission: data => dispatch(actions.updatePermission(data)),
        onLoadRoles: user => dispatch(actions.loadRoles(user)),
        onFetchCustomer: (id) => dispatch(actions.fetchCustomer(id)),
        cleanState: () => dispatch(actions.cleanState()),
        fetchPermission: user => dispatch(actions.fetchPermission(user)),
        onFetchCustomers: (id) => dispatch(actions.fetchCustomers(id)),
        onEditUser: user => dispatch(actions.editUser(user)),
        onLoadUser: user => dispatch(actions.loadUser(user)),
        onFetchGroups: data => dispatch(fetchGroups(data)),
        onFetchBulkChangeUsersGroup: data => dispatch(fetchBulkChangeUsersGroup(data)),
        onEditIndividualLicenses: data => dispatch(editIndividualLicenses(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(UserComponents));